export default "__VITE_ASSET__jgZcMOBh__"